import { IntlShape } from "gatsby-plugin-intl"
import { extractOptionalTranslation } from "./extractOptionalTranslation"

export function translateGeoRegion(region: string, intl: IntlShape) {
  if (!region) {
    return ""
  }
  return extractOptionalTranslation({
    parentKey: "geoRegions",
    subKey: region,
    intl,
  })
}
